/* PielPet — video de fondo y producto con ingredientes que aparecen al hacer scroll. */
(function () {
  'use strict';

  var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Video de fondo: se reproduce en loop; se pausa si la persona pidió menos movimiento */
  function iniciarVideos(raiz) {
    (raiz || document).querySelectorAll('[data-video-fondo]').forEach(function (video) {
      video.muted = true;
      if (reducir) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }
      var intento = video.play && video.play();
      if (intento && intento.catch) intento.catch(function () {});
    });
  }

  /* Producto con ingredientes */
  function iniciarIngredientes(seccion) {
    if (seccion.dataset.iniciado) return;
    seccion.dataset.iniciado = '1';

    var pildoras = Array.prototype.slice.call(seccion.querySelectorAll('[data-pildora]'));
    var contador = seccion.querySelector('[data-contador]');
    var escena = seccion.querySelector('[data-escena]');
    var total = pildoras.length;
    if (!total || !escena) return;

    var animar = document.documentElement.classList.contains('animado') && !reducir;
    var esComputador = window.matchMedia('(min-width: 750px)');

    function posicionar() {
      var orbita = esComputador.matches;
      seccion.classList.toggle('ing-orbita', orbita);
      if (!orbita) return;
      var caja = escena.getBoundingClientRect();
      var rx = Math.min(caja.width * 0.36, 440);
      var ry = Math.min(caja.height * 0.4, 270);
      seccion.style.setProperty('--rx', rx + 'px');
      seccion.style.setProperty('--ry', ry + 'px');
      pildoras.forEach(function (p, i) {
        var angulo = (-90 + (360 / total) * i) * Math.PI / 180;
        p.style.setProperty('--x', Math.round(Math.cos(angulo) * rx) + 'px');
        p.style.setProperty('--y', Math.round(Math.sin(angulo) * ry) + 'px');
      });
    }

    if (!animar) {
      posicionar();
      window.addEventListener('resize', posicionar);
      pildoras.forEach(function (p) { p.classList.add('visible'); });
      if (contador) contador.textContent = total;
      return;
    }

    seccion.classList.add('ing-listo');
    posicionar();

    var visibles = -1;
    var pendiente = false;
    function actualizar() {
      pendiente = false;
      var caja = seccion.getBoundingClientRect();
      var recorrido = caja.height - window.innerHeight;
      var progreso = recorrido > 0 ? Math.min(1, Math.max(0, -caja.top / recorrido)) : 1;
      seccion.style.setProperty('--progreso', progreso.toFixed(3));
      var n = progreso <= 0.04 ? 0 : Math.min(total, Math.ceil(((progreso - 0.04) / 0.8) * total));
      if (n !== visibles) {
        visibles = n;
        pildoras.forEach(function (p, i) { p.classList.toggle('visible', i < n); });
        if (contador) contador.textContent = n;
      }
    }
    function pedirActualizacion() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(actualizar);
    }
    window.addEventListener('scroll', pedirActualizacion, { passive: true });
    window.addEventListener('resize', function () { posicionar(); pedirActualizacion(); });
    actualizar();
  }

  /* Botones "Pedir ahora": abren directo el formulario de contra entrega (Releasit).
     Si el formulario todavía no cargó, bajan a la caja de compra como siempre. */
  function botonFormulario() {
    var candidatos = document.querySelectorAll('#rsi_buy_now_button, [id^="rsi_buy_now_button"]');
    for (var i = 0; i < candidatos.length; i++) {
      if (candidatos[i].getClientRects().length) return candidatos[i];
    }
    return null;
  }
  document.addEventListener('click', function (ev) {
    var enlace = ev.target.closest('a[href]');
    if (!enlace || ev.defaultPrevented || ev.metaKey || ev.ctrlKey) return;
    var href = enlace.getAttribute('href') || '';
    var marca = href.indexOf('#');
    if (marca === -1 || href.slice(marca + 1) !== 'comprar') return;
    if (!document.getElementById('comprar')) return;
    var boton = botonFormulario();
    if (!boton) return;
    ev.preventDefault();
    boton.click();
  });

  function iniciar(raiz) {
    iniciarVideos(raiz);
    (raiz || document).querySelectorAll('[data-ingredientes]').forEach(iniciarIngredientes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', function (ev) { iniciar(ev.target); });
})();
